import {
    Component,
    forwardRef,
    HostBinding,
    inject,
    input,
    model,
    output
} from '@angular/core';
import {
    AbstractControl,
    ControlContainer,
    ControlValueAccessor,
    FormGroupDirective,
    FormsModule,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    ReactiveFormsModule,
    ValidationErrors,
    Validator
} from '@angular/forms';
import { ZSelectComponent } from '../../form-components/z-select/z-select.component';

import { Store } from '@ngxs/store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
    ProductUnitTypeType,
    ProductUnitTypeGraphQLSchemaSelectors,
    ProductUnitTypeGraphQLSchemaActions,
    ProductUnitTypeTypeQuery
} from '@shared/zigra-schemas/zigra-schema.autogenerated.models';

@Component({
    selector: 'z-product-meter-unit-select',
    imports: [ZSelectComponent, FormsModule, ReactiveFormsModule],
    templateUrl: './z-product-meter-unit-select.component.html',
    styleUrl: './z-product-meter-unit-select.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ZProductMeterUnitSelectComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: ZProductMeterUnitSelectComponent
        }
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ]
})
export class ZProductMeterUnitSelectComponent
    implements ControlValueAccessor, Validator
{
    @HostBinding('class') class?: string = 'flex flex-auto';

    mode = model<'edit' | 'view'>('view');
    label = input<string | undefined>('Μονάδα Μέτρησης');
    showLabel = input<boolean | undefined>();
    autocomplete = input<string | undefined>(undefined);
    id = input<string | undefined>(undefined);
    optionLabel = input<string | undefined>('Title');
    optionValue = input<string | undefined>('_id');
    options = model<ProductUnitTypeType[] | undefined>(undefined);
    placeholder = input<string | undefined>(undefined);
    productUnitTypeChange = output<ProductUnitTypeType | undefined>();

    store = inject(Store);

    constructor() {
        // this.store
        //     .select(ProductUnitTypeGraphQLSchemaSelectors.FetchSelector('', ''))
        //     .pipe(takeUntilDestroyed())
        //     .subscribe((value) => {
        //         if (this.options() == undefined)
        //             this.options.set(value?.data?.Fetch);
        //     });
    }

    /* NG_VALUE_ACCESSOR Implementation */
    // https://blog.angular-university.io/angular-custom-form-controls/
    disabled?: boolean;
    model: any;
    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    writeValue(obj: any): void {
        this.model = obj;
    }
    registerOnChange(fn: any): void {
        this.onModelChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onModelTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return null;
    }
    registerOnValidatorChange?(fn: () => void): void {
        // throw new Error('Method not implemented.');
    }
    /* /NG_VALUE_ACCESSOR Implementation */

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        // Αυτή εδώ η προσεγγίση είναι καλή για μια εγγραφή.
        // αν έχουμε πολλές εγγραφές αυτό θα εκτελεστεί πολλές φορές γιατί όλα είναι παράλληλα
        // άρα θα πρέπει να στείλουμε τα options εξωτερικά μέσω της 'this.options()'.
        console.debug('z-product-meter-unit-select.component -> loadData ', {
            otpions: this.options,
            store: this.store.selectSnapshot(
                ProductUnitTypeGraphQLSchemaSelectors.FetchSelector('', '')
            )?.data?.Fetch
        });

        if (this.options() == undefined) {
            (
                this.store.selectSnapshot(
                    ProductUnitTypeGraphQLSchemaSelectors.FetchSelector('', '')
                )?.data?.Fetch ?? []
            ).length == 0
                ? this.store
                      .dispatch(
                          new ProductUnitTypeGraphQLSchemaActions.Fetch(
                              ProductUnitTypeTypeQuery.GQLQuery(),
                              undefined
                          )
                      )
                      .subscribe(() => {
                          this.options.set(
                              this.store.selectSnapshot(
                                  ProductUnitTypeGraphQLSchemaSelectors.FetchSelector(
                                      '',
                                      ''
                                  )
                              )?.data?.Fetch
                          );
                      })
                : undefined;
        }
    }

    modelChange(_id: string) {
        debugger;
        this.onModelChange(_id);
        const selectedProductUnit = this.options()?.find(
            (option) => option._id == _id
        );
        if (selectedProductUnit != undefined)
            this.productUnitTypeChange.emit(selectedProductUnit);
    }
}
